// extracted by mini-css-extract-plugin
module.exports = {"block":"FooterMenu_block__a_r9k","icon":"FooterMenu_icon__ZtZlj","item":"FooterMenu_item__9em7F","fadeOut":"FooterMenu_fadeOut__qPd07"};